import type { Locale } from "../Locale.js";

export function getHowItWorksAnchor(locale: Locale): string {
	return { cs: "#jak-to-funguje", en: "#how-it-works" }[locale];
}
